export type LandingLocale = 'el' | 'en';

export type LandingScreenKey = 'hero' | 'discover' | 'book' | 'bookings';

const screens: Record<LandingScreenKey, Record<LandingLocale, string | null>> = {
  hero: {
    el: '/screenshots/screen-details-gr.png',
    en: '/screenshots/screen-details-en.png',
  },
  discover: {
    el: '/screenshots/screen1-gr.png',
    en: '/screenshots/screen1-en.png',
  },
  book: {
    el: '/screenshots/screen-calend-gr.png',
    en: '/screenshots/screen-calend-en.png',
  },
  bookings: {
    el: '/screenshots/screen-book-gr.png',
    en: '/screenshots/screen-book-en.png',
  },
};

export function getLandingScreen(
  key: LandingScreenKey,
  locale: LandingLocale,
): string | null {
  return screens[key][locale];
}
